import React, { useState } from 'react';
import { ArrowRightIcon, FilterIcon, ClockIcon, MapPinIcon } from 'lucide-react';
import FlightSearchForm from '../components/FlightSearchForm';
const SearchPage = () => {
  const [activeTab, setActiveTab] = useState('all');
  return <div className="container mx-auto px-4 py-8" data-id="element-262">
      <h1 className="text-3xl font-bold mb-6" data-id="element-263">Search Flights</h1>
      <div className="bg-white rounded-lg shadow-md p-6 mb-8" data-id="element-264">
        <FlightSearchForm data-id="element-265" />
      </div>
      <div className="flex justify-between items-center mb-6" data-id="element-266">
        <div className="flex space-x-4" data-id="element-267">
          <button className={`px-4 py-2 rounded-md ${activeTab === 'all' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`} onClick={() => setActiveTab('all')} data-id="element-268">
            All Flights
          </button>
          <button className={`px-4 py-2 rounded-md ${activeTab === 'scheduled' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`} onClick={() => setActiveTab('scheduled')} data-id="element-269">
            Scheduled
          </button>
          <button className={`px-4 py-2 rounded-md ${activeTab === 'active' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`} onClick={() => setActiveTab('active')} data-id="element-270">
            In Air
          </button>
          <button className={`px-4 py-2 rounded-md ${activeTab === 'arrived' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`} onClick={() => setActiveTab('arrived')} data-id="element-271">
            Arrived
          </button>
        </div>
        <button className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-272">
          <FilterIcon className="h-5 w-5 mr-2" data-id="element-273" />
          Filters
        </button>
      </div>
      <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-274">
        <div className="overflow-x-auto" data-id="element-275">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-276">
            <thead className="bg-gray-50" data-id="element-277">
              <tr data-id="element-278">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-279">
                  Flight
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-280">
                  Route
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-281">
                  Scheduled
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-282">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-283">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-284">
              {mockFlights.map(flight => <tr key={flight.id} className="hover:bg-gray-50" data-id="element-285">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-286">
                    <div className="flex items-center" data-id="element-287">
                      <div className="h-10 w-10 flex-shrink-0" data-id="element-288">
                        <img className="h-10 w-10 rounded-full" src={flight.airlineLogo} alt={flight.airline} data-id="element-289" />
                      </div>
                      <div className="ml-4" data-id="element-290">
                        <div className="text-sm font-medium text-gray-900" data-id="element-291">
                          {flight.flightNumber}
                        </div>
                        <div className="text-sm text-gray-500" data-id="element-292">
                          {flight.airline}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-293">
                    <div className="flex items-center" data-id="element-294">
                      <div className="text-sm font-medium text-gray-900" data-id="element-295">
                        {flight.departure.code}
                      </div>
                      <ArrowRightIcon className="h-4 w-4 mx-2 text-gray-400" data-id="element-296" />
                      <div className="text-sm font-medium text-gray-900" data-id="element-297">
                        {flight.arrival.code}
                      </div>
                    </div>
                    <div className="text-sm text-gray-500" data-id="element-298">
                      {flight.departure.city} to {flight.arrival.city}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-299">
                    <div className="flex flex-col" data-id="element-300">
                      <div className="flex items-center text-sm text-gray-900" data-id="element-301">
                        <ClockIcon className="h-4 w-4 mr-1 text-gray-400" data-id="element-302" />
                        <span data-id="element-303">Dep: {flight.scheduledDeparture}</span>
                      </div>
                      <div className="flex items-center text-sm text-gray-900 mt-1" data-id="element-304">
                        <ClockIcon className="h-4 w-4 mr-1 text-gray-400" data-id="element-305" />
                        <span data-id="element-306">Arr: {flight.scheduledArrival}</span>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-307">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusColor(flight.status)}`} data-id="element-308">
                      {flight.status}
                    </span>
                    {flight.delay && <div className="text-sm text-red-600 mt-1" data-id="element-309">
                        Delayed: {flight.delay}
                      </div>}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-310">
                    <button className="text-blue-600 hover:text-blue-900 mr-3" data-id="element-311">
                      Details
                    </button>
                    <button className="text-blue-600 hover:text-blue-900" data-id="element-312">
                      Set Alert
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};
// Helper function to get status color
const getStatusColor = status => {
  switch (status.toLowerCase()) {
    case 'on time':
      return 'bg-green-100 text-green-800';
    case 'delayed':
      return 'bg-yellow-100 text-yellow-800';
    case 'cancelled':
      return 'bg-red-100 text-red-800';
    case 'in air':
      return 'bg-blue-100 text-blue-800';
    case 'arrived':
      return 'bg-purple-100 text-purple-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
// Mock flight data
const mockFlights = [{
  id: 1,
  flightNumber: 'AA1234',
  airline: 'American Airlines',
  airlineLogo: 'https://logos-world.net/wp-content/uploads/2020/03/American-Airlines-Logo-700x394.png',
  departure: {
    code: 'JFK',
    city: 'New York'
  },
  arrival: {
    code: 'LAX',
    city: 'Los Angeles'
  },
  scheduledDeparture: '08:30 AM',
  scheduledArrival: '11:45 AM',
  status: 'On Time',
  delay: null
}, {
  id: 2,
  flightNumber: 'DL5678',
  airline: 'Delta Air Lines',
  airlineLogo: 'https://logos-world.net/wp-content/uploads/2020/03/Delta-Air-Lines-Logo-700x394.png',
  departure: {
    code: 'ATL',
    city: 'Atlanta'
  },
  arrival: {
    code: 'ORD',
    city: 'Chicago'
  },
  scheduledDeparture: '09:15 AM',
  scheduledArrival: '10:20 AM',
  status: 'Delayed',
  delay: '45 min'
}, {
  id: 3,
  flightNumber: 'UA9012',
  airline: 'United Airlines',
  airlineLogo: 'https://logos-world.net/wp-content/uploads/2020/03/United-Airlines-Logo-700x394.png',
  departure: {
    code: 'SFO',
    city: 'San Francisco'
  },
  arrival: {
    code: 'SEA',
    city: 'Seattle'
  },
  scheduledDeparture: '10:00 AM',
  scheduledArrival: '12:15 PM',
  status: 'In Air',
  delay: null
}, {
  id: 4,
  flightNumber: 'BA3456',
  airline: 'British Airways',
  airlineLogo: 'https://logos-world.net/wp-content/uploads/2020/03/British-Airways-Logo-700x394.png',
  departure: {
    code: 'LHR',
    city: 'London'
  },
  arrival: {
    code: 'JFK',
    city: 'New York'
  },
  scheduledDeparture: '02:30 PM',
  scheduledArrival: '05:45 PM',
  status: 'Cancelled',
  delay: null
}, {
  id: 5,
  flightNumber: 'LH7890',
  airline: 'Lufthansa',
  airlineLogo: 'https://logos-world.net/wp-content/uploads/2020/03/Lufthansa-Logo-700x394.png',
  departure: {
    code: 'FRA',
    city: 'Frankfurt'
  },
  arrival: {
    code: 'CDG',
    city: 'Paris'
  },
  scheduledDeparture: '11:20 AM',
  scheduledArrival: '12:35 PM',
  status: 'Arrived',
  delay: null
}];
export default SearchPage;